<script setup lang="ts">
import { faFlag } from '@fortawesome/pro-regular-svg-icons';

type Props = {
    domesticStops?: number;
    internationalStops?: { title: string }[];
};

defineProps<Props>();

const emit = defineEmits<{
    close: [];
}>();
</script>

<template>
    <mr-modal title="توقف ها" width="320px" @close="emit('close')">
        <div class="stops-container">
            <mr-typography v-if="domesticStops">
                توقف های نامشخص: {{ domesticStops }}
            </mr-typography>
            <mr-divider
                v-if="domesticStops && internationalStops?.length"
                :thickness="1"
            />
            <template v-if="internationalStops?.length">
                <mr-typography> توقف های مشخص: </mr-typography>
                <div
                    v-for="({ title }, index) in internationalStops"
                    :key="title + index"
                    class="stop"
                >
                    <mr-icon :icon="faFlag" />
                    <mr-typography> توقف در {{ title }} </mr-typography>
                </div>
            </template>
        </div>
    </mr-modal>
</template>

<style scoped lang="scss">
.stops-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    .stop {
        display: flex;
        align-items: center;
        gap: 8px;
    }
}
</style>
